import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { getIsMobile } from 'Store/Screen/selectors';
import { staticContent } from 'Components/MenuTop/MenuTopContent';
import MenuTop from 'Components/MenuTop/MenuTop';

import { 
  getUserName, 
  getIsLoggedIn, 
  getUserEmail, 
  getIsFetchingUser,
} from 'Store/User/selectors';

interface IState {
  isCustomerMenuVisible: boolean;
}

interface IPropsInternal {
  isMobile: boolean;
  isFetchingUser: boolean;
  userName: string;
  userEmail: string;
  isLoggedIn: boolean;
}

type Props = IPropsInternal;

class MenuTopContainer extends React.PureComponent<Props, IState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isCustomerMenuVisible: false,
    };
  }

  onMyPageClick = () => {
    this.setState({ isCustomerMenuVisible: !this.state.isCustomerMenuVisible });
  }

  onCloseCustomerMenu = () => {
    this.setState({ isCustomerMenuVisible: false });
  }

  getMenuItems() {
    const { isLoggedIn, isFetchingUser, userName, userEmail } = this.props;

    if (isFetchingUser) {
      return { 
        ...staticContent, 
        buttonMyPage: { 
          ...staticContent.buttonMyPage,
          displayName: '',
          formattedName: '',
          iconType: '',
        },
      };
    }

    if (!isLoggedIn) {
      return staticContent;
    }

    return { 
      ...staticContent, 
      buttonMyPage: { 
        ...staticContent.buttonMyPage,
        displayName: userName ? userName : userEmail,
        formattedName: null,
        iconType: 'user',
      },
    };
  }

  render() {
    const menuItems = this.getMenuItems();

    return (
      <MenuTop 
        isMobile={ this.props.isMobile }
        isCustomerMenuVisible={ this.state.isCustomerMenuVisible }
        onCloseCustomerMenu={ this.onCloseCustomerMenu }
        onMyPageClick={ this.onMyPageClick }
        { ...menuItems }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isMobile: getIsMobile(state),
    isFetchingUser: getIsFetchingUser(state),
    userName: getUserName(state),
    userEmail: getUserEmail(state),
    isLoggedIn: getIsLoggedIn(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(MenuTopContainer);


// WEBPACK FOOTER //
// ./src/components/MenuTop/MenuTopContainer.tsx